<script>
    import {Bar, mixins} from 'vue-chartjs';

    export default {
        name   : "StatActiveCardsChart",
        extends: Bar,
        mixins : [mixins.reactiveProp],
        props  : {
            chartData: {
                type   : Object,
                default: null
            },
            options  : {
                type   : Object,
                default: null
            },
            interval : {
                type   : String,
                default: null
            }
        },
        mounted() {

            this.renderChart(
                this.chartData,
                {
                    responsive         : true,
                    maintainAspectRatio: false,
                    legend             : {
                        display: false,
                    },
                    scales             : {
                        xAxes: [{
                            type        : 'time',
                            distribution: 'series',
                            offset      : true,
                            ticks       : {
                                autoSkip: true,
                                source  : 'data',
                            },
                            time        : {
                                unit         : 'day',
                                tooltipFormat: 'MMM D, YYYY',
                            },
                            gridLines   : {
                                // display: false
                            }
                        }],
                        yAxes: [{
                            stacked  : true,
                            ticks    : {
                                autoSkip     : true,
                                maxTicksLimit: 1,
                                min          : 0,
                            },
                            gridLines: {
                                display: false
                            }
                        }]
                    },
                    tooltips           : {
                        position: 'nearest',
                    },
                }
            );
        },
    }
</script>

<style scoped>

</style>
